import useOnEnvironmentLoads from "./on-environment-loads";
import useOnEnvironmentChangedByUser from "./on-environment-change-by-user";

// This is a hook used for running a function when the environment is changed for any reason
function useOnEnvironmentSet(callback: Function) {
  useOnEnvironmentLoads(callback);
  useOnEnvironmentChangedByUser(callback);
}

export default useOnEnvironmentSet;
